import { render, staticRenderFns } from "./Final.vue?vue&type=template&id=5bf2fc40&scoped=true&"
import script from "./Final.vue?vue&type=script&lang=js&"
export * from "./Final.vue?vue&type=script&lang=js&"
import style0 from "./Final.vue?vue&type=style&index=0&id=5bf2fc40&scoped=true&lang=css&"
import style1 from "./Final.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf2fc40",
  null
  
)

export default component.exports